<template>
  <v-container>
    <div>
      <div class="row">
        <v-row>
          <v-col cols="12" md="6" sm="12">
            <Ranking />
          </v-col>
          <v-col cols="12" md="6" sm="12">
            <img :src="$store.state.unidad.logo" class="img-responsive mx-2" style="width:50%!important" />

            <h4 class="mx-3">NUESTRA MISIÓN</h4>
            <p class="mx-3">
              {{ $store.state.unidad.mision }}
            </p>

            <h4 class="mx-3">NUESTRA VISIÓN</h4>
            <p class="mx-3">
              {{ $store.state.unidad.vision }}
            </p>

            <h4 class="mx-3">NUESTROS VALORES</h4>
            <ul class="mx-3" style="text-align: left">
              <li>Espiritu de triunfo</li>
              <li>Trabajo en equipo</li>
              <li>Cooperación</li>
              <li>Identidad</li>
              <li>Responsabilidad</li>
              <li>Ética</li>
              <li>Respeto</li>
              <li>Creatividad</li>
              <li>Satisfacción</li>
              <li>Excelencia</li>
            </ul>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-container>
</template>

<script>
  // @ is an alias to /src
  import Ranking from '@/views/Ranking.vue';

  export default {
    name: 'home',
    components: { Ranking },
    data() {
      return {};
    },
    watch: {},
    methods: {},
    mounted() {},
  };
</script>
